import { ReferenceManyField, TextField } from 'react-admin';
import { CheckRecordActiveSwitch } from '@/pages/Candidate/view/utils';
import { MainDatagridStyled } from '@/styles/overrides';
import { FCRAWorkerCheckRecordTypeEnum, TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import AccordionWrapper from '../AccordionWrapper';
import { path } from '../constants';

const Actions = () => {
  return (
    <AccordionWrapper title="Actions">
      <ReferenceManyField
        label={false}
        reference={TurnReferencesEnum.Candidates}
        target={TurnTargetsEnum.WorkerMvrActions}
      >
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <CheckRecordActiveSwitch type={FCRAWorkerCheckRecordTypeEnum.MvrAction} />
          <TextField emptyText="false" sortable={false} source={path('active')} />
          <TextField label="ID" sortable={false} source={path('id')} />
          <TextField label="Action Code" sortable={false} source={path('action_code')} />
          <TextField label="Action Type" sortable={false} source={path('action_type')} />
          <TextField label="Docket" sortable={false} source={path('locations.0.docket')} />
          <TextField label="State" sortable={false} source={path('locations.0.state')} />
          <TextField label="Thru Date" sortable={false} source={path('thru_date')} />
          <TextField label="Actual End Date" sortable={false} source={path('actual_end_date')} />
          <TextField label="ACD Code" sortable={false} source={path('sub_violations.0.acd_code')} />
          <TextField label="ACD Description" sortable={false} source={path('sub_violations.0.acd_code_description')} />
          <TextField label="Key" sortable={false} source={path('sub_violations.0.key')} />
          <TextField
            label="Short Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.short_description')}
          />
          <TextField
            label="State Description"
            sortable={false}
            source={path('sub_violations.0.descriptions.0.state_description')}
          />
        </MainDatagridStyled>
      </ReferenceManyField>
    </AccordionWrapper>
  );
};

export default Actions;
